import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from './modules/user'
import tim from './modules/tim'
import popup from './modules/popup'
import room from './modules/room'
import products from './modules/products'

const store = new Vuex.Store({
  state: {
    clientWidth: document.documentElement.clientWidth
  },

  modules: {
    user,
    tim,
    popup,
    room,
    products
  }
})

export default store